export const ar = {
    "TRIGGER_LISTEN": "الاستماع إلى المشغلات",
    "ASSIST_EMPTY_MSG": "يقوم Agent AI حاليًا بالاستماع بنشاط إلى محادثتك وجاهز للمساعدة تلقائيًا عند التنشيط.",
    "MYBOT_TRIGGET_LISTEN": "لا توجد مهام My Bot نشطة حاليًا",
    "MYBOT_EMTPY_MSG": "لبدء مهمة على My Bot ، انتقل إلى علامة التبويب de recherche et sélectionnez l'option \"Exécuter avec les entrées de l'agent\" pour la tâche souhaitée.",
    "PROACTIVE_MODE": "الوضع الاستباقي",
    "SETTINGS": "الإعدادات",
    "HELP_AND_SUPPORT": "المساعدة والدعم",
    "HELP": "مساعدة",
    "LANGUAGE": "لغة",
    "THEME": "موضوع",
    "AUTOMATIC": "تلقائي",
    "DARK": "داكن",
    "LIGHT": "فاتح",
    "THEME_DESC": "سيتم استخدام وضع النظام الافتراضي الخاص بك",
    "DOCUMENTATION": "توثيق",
    "DOC_DESC": "تحقق من مقالات التوثيق العميقة الخاصة بنا.",
    "FAQ_U": "الأسئلة الشائعة",
    "FAQ_DESC": "تحقق من الأسئلة المتكررة حول Agent AI.",
    "KORE_ACADEMY": "أكاديمية كوري",
    "KORE_ACA_DESC": "تعرف على المزيد حول Agent AI من خلال الانتقال إلى دورات الأكاديمية.",
    "SEARCH": "بحث",
    "MY_BOT": "بوتي",
    "ASSIST": "مساعدة",
    "TRANSCRIPT": "النص",
    "HISTORY": "التاريخ",
    "STARTOVER": "ابدأ من جديد",
    "RESTART_INPUTS": "إعادة التشغيل باستخدام الإدخالات الملتقطة",
    "ASKCUSTOMER": "اسأل الزبون",
    "TELLCUSTOMER": "قل للزبون",
    "WELCOME_MSG": "رسالة الترحيب",
    "SEND": "إرسال",
    "SENT": "تم الإرسال",
    "AWAITING": "في انتظار الرد | اكتب للمتابعة",
    "OVERRIDE": "اكتب للمتابعة",
    "ACCEPT_RESPONSE": "قبول الرد",
    "AGENT_ENTERED": "دخل الوكيل",
    "EXPECTED_FORMAT": "التنسيق المتوقع",
    "INPUT_VALUES": "قيم الإدخال",
    "RESTART": "إعادة التشغيل",
    "START_OVER": "ابدأ من جديد",
    "RESTART_CAPTURE": "إعادة التشغيل باستخدام الإدخالات الملتقطة",
    "CANCEL": "إلغاء",
    "INTERRUPT_DIALOG": "تم الانقطاع عن مهمة الحوار",
    "RUN": "تشغيل",
    "RUN_AGENT": "تشغيل بإدخال الوكيل",
    "STEP": "خطوة",
    "DIALOG_TASK": "مهمة الحوار",
    "FAQ": "الأسئلة الشائعة",
    "SNIPPET": "إجابات",
    "ARTICLE": "صفحات الويب",
    "FILE": "الملفات",
    "SUGGESTED": "مقترح",
    "ALL_DIALOG": "جميع مهام الحوار",
    "TAP_SEARCH":"اضغط للبحث",
    "AUTO_SCROLL_TOOLTIP":"تتحكم علامات التبويب تعليمات وMy Bots وTranscript في التمرير التلقائي للمحتوى",
    "ASK_A_QUESTION":"اطرح سؤالاً",
    "DIALOG_TEXT": "حوار",
    "INTENT_IDENTIFIED": "مدخل العميل",
    "NOT_WHAT_LOOKING": "اقتراح خاطئ؟",
    "BOT": "بوت",
    "CUSTOMER": "زبون",
    "AUTOSCROLL_ASSIST":"مساعدة التمرير التلقائي",
    "YOU": "أنت",
    "TERMINATE_CONV": "إنهاء مهمة الحوار",
    "TERMINATE_CONV_DESC": "هل أنت متأكد أنك تريد إنهاء مهمة الحوار؟ لن يكون Agent AI قادرًا على تقديم اقتراحات بعد الآن.",
    "YES_TERMINATE": "نعم، إنهاء",
    "NO_CANCEL": "لا، إلغاء",
    "OVERRIDE_CONTINUE": "متابعة بوضع التجاوز",
    "SUMMARY_TEXT": "ملخص",
    "SUBMIT": "إرسال",
    "INTERRUPT_OCCURED": "حدث انقطاع",
    "IDENTIFIED_INTENT": "النية المحددة",
    "INTERRUPT_DESC": "سيؤدي تشغيل هذا إلى إنهاء مهمة الحوار الجارية الخاصة بك.",
    "ACCEPT_RUN": "قبول وتشغيل",
    "RUN_LATER": "تشغيل لاحقًا",
    "KNOW_MORE": "تعرف أكثر",
    "MORE_TEXT": "المزيد",
    "LESS_TEXT": "أقل",
    "VIEW_MORE": "عرض المزيد",
    "VIEW_LESS": "عرض أقل",
    "SHOW_MORE_FAQ": "عرض المزيد من الأسئلة الشائعة",
    "SHOW_LESS_FAQ": "عرض أقل من الأسئلة الشائعة",
    "SHOW_MORE_ARTICLE": "عرض المزيد من صفحات الويب",
    "SHOW_LESS_ARTICLE": "عرض أقل من صفحات الويب",
    "SHOW_MORE_SNIPPET": "عرض المزيد من الإجابات",
    "SHOW_LESS_SNIPPET": "عرض أقل من الإجابات",
    "SHOW_MORE_FILES": "عرض المزيد من الملفات",
    "SHOW_LESS_FILES": "عرض أقل من الملفات",
    "VIEW_ALL_DIALOG": "عرض جميع الحوارات",
    "VIEW_FEW_DIALOG": "عرض بعض الحوارات",
    "HELP_FULL": "مفيد؟",
    "THANKYOU": "شكرًا لك!",
    "EXPAND_MORE": "توسيع \/ المزيد",
    "CLOSE_TEXT": "إغلاق",
    "STARTED": "بدأ",
    "ENDED": "انتهى",
    "FILE_NAME":"اسم الملف",
    "VIEW_FULL_ARTICLE": "عرض صفحة الويب كاملة",
    "VIFILEEW_FULL_": "عرض الملف كامل",
    "VIEW_FULL_FILE": "عرض الملف كامل",
    "COPIED": "تم النسخ",
    "SENTI_ANALY": "تحليل المشاعر",
    "WRONG_SUGGESTION": "اقتراح خاطئ",
    "INCORRECT_INTENT": "نية غير صحيحة",
    "ACCIDENTAL_CLICK": "نقر غير مقصود",
    "TAB_TEXT":"لم يتم تمكين أي علامات تبويب! يرجى تمكين علامة تبويب واحدة على الأقل",
    "TIME_TAKING": "يأخذ وقتًا",
    "OTHER": "آخر",
    "PLAYBOOK_EMPTY_MSG": "حدد Playbook",
    "PLAYBOOK_EMPTY_DESC": "لا يمكن لـ Agent AI تحميل الدليل التعليمي بسبب كل الدليل المتاح كانت ديناميكية. انقر فوق 'تحديد دليل' للوصول إلى الدليل",
    "STAGE": "مرحلة",
    "PROCEED_TO_CLOSE": "تابع للإغلاق",
    "RECOMENDED_PLAYBOOK": "الكتيب الموصى به",
    "PRIMARY_SCRIPTS": "النصوص الأساسية",
    "DYNAMIC_SCRIPTS": "النصوص الديناميكية",
    "RESUME": "استئناف",
    "ENABLE_CLOSE": "انقر فوق زر \"تابع للإغلاق\" لتمكين مرحلة الإغلاق",
    "LIST_VIEW": "عرض القائمة",
    "TERMINATE": "إنهاء",
    "MINIMIZE": "تصغير",
    "MAXIMIZE": "تكبير",
    "NO_SEARCH_RESULT": "لا توجد نتائج بحث",
    "SENTIMENT_AWAITING": "في انتظار المشاعر",
    "POSITIVE": "إيجابي",
    "NEGATIVE": "سلبي",
    "COPY" : "نسخ",
    "TELL_US_MORE": "أخبرنا المزيد",
    "THANKS_FEEDBACK": "شكرًا على ملاحظاتك",
    "VIEW_FULL_ARTICLE_2": "عرض المقالة الكاملة",
    "VIEW_FULL_FILE_2": "عرض الملف بالكامل",
    "SOMETHING_WRONG": "حدث خطأ ما",
    "CLICK_ERROR_DETAILS": "انقر لرؤية تفاصيل الخطأ",
    "NO_ACTIVE_PLAYBOOK": "لا يوجد كتيب تشغيل نشط",
    "REPHRASE_QUESTION": "هل يمكنك إعادة صياغة سؤالك أو طرح شيء آخر؟",
    "INTERNAL_INFO": "معلومات داخلية",
    "SOURCES": "المصادر",
    "CONVERSATION_SUMMARY": "ملخص المحادثة",
    "WAITING": "انتظار",
    "WIDGET_DISABLED": "الأداة معطلة",
    "AI_SETTINGS_DISABLED": "تم تعطيل إعدادات وكيل الذكاء الاصطناعي! يرجى التواصل مع المسؤول",
    "SERVER_CONNECTION_ERROR": "حدث خطأ أثناء الاتصال بالخادم",
    "VIEW": "عرض",
    "ATTACHMENT_INPUT": "إدخال المرفق",
    "TYPE_SUMMARY": "اكتب الملخص",
    "BY":"بواسطة",
    "PLAYBOOK": "دليل اللعب",
    "GENERATE_SUMMARY": "إنشاء ملخص",
    PREV_SUMMARIES: "الملخصات التي تم إنشاؤها سابقًا",
    DIALOG_WORKFLOWS: "سير عمل الحوارات",
    SHOW_ALL_DIALOG: "إظهار جميع مهام الحوار",
    SHOW_ALL_DIALOGS: "إظهار جميع الحوارات",
    CUSTOM_TAB: "علامة تبويب مخصصة",
    AGENT_INPUT: "مدخل الوكيل",
    "CUSTOM_EMPTY_MSG" : "لا يوجد سير عمل نشط حالياً",
    "CUSTOM_TAB_DESC" : "لبدء سير عمل ، قم بتنفيذ واحد من القائمة الموجودة في الأسفل.",
    "SUBMIT_OVERALL_FEEDBACK" : "إرسال تقييم عام",
    "FEEDBACK_POPUP_SUBTITLE" : "كم سعدت بالأداة وميزاتها؟",
    "FEEDBACK_SATISFIED" : "مرضي",
    "FEEDBACK_UNSATISFIED" : "غير مرضي",
    "FEEDBACK_PROVIDE_REASONS" : "أخبرنا المزيد",
    "FEEDBACK_TITLE" : "تقييم",
    "AGENTIC_THINKING" : "يفكر",
    "AGENTIC_AGENT_TITLE" : "الوكيل",
    "AGENTIC_COPILOT_MODE_TITLE" : "وضع مساعد الوكيل",
    "AGENTIC_SENDING_MESSAGE" : "جاري الإرسال...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot يستمع بنشاط إلى محادثتك ومستعد للمساعدة تلقائيًا",
    "AGENTIC_SEARCH_RESULTS" : "النتائج الآلية"
}